/**
 * 设备管理-校牌管理-sim卡非法校验名单管理
 */
import request from '@/utils/request';
import { getToken } from '@/utils/auth';
import ENVIRONMENT from '@/utils/environment';

/**
 * 填写1是导出IMEI卡导入模板 2是导出SIM卡导入模板 3是导出欠费校验白名单管理
 */
export function illegalCheckExcelTemplate(simType) {
  return `${ENVIRONMENT.BASE_API}/op/schoolcardMandger/excelTemplate?simType=${simType}&token=${getToken()}`;
}

/**
 * 获取学校列表
 */
export function getSchoolList(options) {
  return request({
    url: `/op/schoolcardMandger/getSchoolList`,
    method: 'get',
    params: options
  });
}
/**
 * 获取导入表格错误信息
 */
export function getErrorText(options) {
  return request({
    url: `/op/schoolcardMandger/getErrorText`,
    method: 'get',
    params: options
  });
}

/**
 * 分页获取iccid mobile
 */
export function getIllegalCheckIccidList(options) {
  return request({
    url: `/op/schoolcardMandger/query/card-mobile/page`,
    method: 'get',
    params: options
  });
}
/**
 * 批量添加SIM iccid mobile
 */
export function getIllegalCheckIccidAdd(options) {
  return request({
    url: `/op/schoolcardMandger/batch-add/card-mobile`,
    method: 'post',
    data: options
  });
}

/**
 *编辑Sim卡叠加包状态
 */
export function getUpdateSimStatus(options) {
  return request({
    url: `/op/schoolcardMandger/updateSimStatus`,
    method: 'post',
    data: options
  });
}

/**
 *删除SIM card mobile
 */
export function getIllegalCheckIccidDel(options) {
  return request({
    url: `/op/schoolcardMandger/delete/card-mobile`,
    method: 'post',
    data: options
  });
}
/**
 *按SIM号进行导出
 */
export function exportSimExcel(options) {
  return `${ENVIRONMENT.BASE_API}/op/schoolcardMandger/exportSimExcel?iccid=${options.iccid}&mobile=${options.mobile}&token=${getToken()}`;
}
/**
 *按Imei号进行导出
 */
export function exportImeiExcel(options) {
  return `${ENVIRONMENT.BASE_API}/op/schoolcardMandger/exportImeiExcel?bindStatus=${options.bindStatus}&schoolCode=${options.schoolCode}&imei=${options.imei}&studentName=${options.studentName}&exprotType=${options.exprotType}&token=${getToken()}`;
}
/**
 *按SIM号进行导入
 */
export function improtExcelSIM() {
  return `${ENVIRONMENT.BASE_API}/op/schoolcardMandger/improtExcelSIM`;
}
/**
 *导入批量修改状态
 */
export function batchUpDateTemplate() {
  return `${ENVIRONMENT.BASE_API}/op/schoolcardMandger/batchUpDateTemplate?token=${getToken()}`;
}
/**
 *按导入IMEI进行导入
 */
export function improtExcelStatus() {
  return `${ENVIRONMENT.BASE_API}/op/schoolcardMandger/improtExcelStatus`;
}
/**
 *按导入IMEI进行导入
 */
export function improtExcelIMEI() {
  return `${ENVIRONMENT.BASE_API}/op/schoolcardMandger/improtExcelIMEI`;
}

/**
 * 分页获取imei校验名单
 */
export function getIllegalCheckImeiList(options) {
  return request({
    url: `/op/schoolcardMandger/query/while-list/page`,
    method: 'get',
    params: options
  });
}

// /**
//  * 批量添加imei while-list
//  */
// export function batchUpDateTemplate(options) {
//   return request({
//     url: `/op/schoolcardMandger/batchUpDateTemplate`,
//     method: 'get'
//   });
// }
/**
 * 批量添加imei while-list
 */
export function getIllegalCheckImeiAdd(options) {
  return request({
    url: `/op/schoolcardMandger/batch-add/while-list`,
    method: 'post',
    data: options
  });
}
/**
 *删除imei while-list
 */
export function getIllegalCheckImeiDel(options) {
  return request({
    url: `/op/schoolcardMandger/delete/while-list`,
    method: 'post',
    data: options
  });
}

// ******************************************************************************************************************************************

/**
 * 分页获取校牌权限
 */
export function getSchooleCardAuthList(options) {
  return request({
    url: `/op/schoolCardAuth/query/schooleCardAuth/page`,
    method: 'get',
    params: options
  });
}

/**
 * 校牌权限USB权限开关
 */
export function getSchooleCardAuthSwitchUSB(options) {
  return request({
    url: `/op/schoolCardAuth/USB_auth_on-off`,
    method: 'get',
    params: options
  });
}
/**
 * 校牌权限向校牌推送设备号
 */
export function getSchooleCardAuthPushDeviceNo(options) {
  return request({
    url: `/op/schoolCardAuth/schoolPushDeviceNo`,
    method: 'post',
    data: options,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

// 学校管理设置*****************************************************************************************************************************************

/**
 * 分页获取学校管理设置列表
 */
export function getSchoolSetList(options) {
  return request({
    url: `/op/schoolManageSet/query/manage_Set_List/page`,
    method: 'get',
    params: options
  });
}
/**
 * 编辑学校定位配置
 */
export function getSchoolSetEdit(options) {
  return request({
    url: `/op/schoolManageSet/save-upd/school-cfg`,
    method: 'post',
    data: options

  });
}

/**
 * 获取回显点读笔选择的资源
 */
export function getOpenShowResource(options) {
  return request({
    url: `/op/schoolManageSet/openShowResource`,
    method: 'get',
    params: options
  });
}
/**
 * 获取回显点读笔选择的资源
 */
export function getResource(options) {
  return request({
    url: `/op/schoolManageSet/openSelectResource`,
    method: 'get',
    data: options
  });
}

/**
 * 获取回显点读笔选择的资源
 */
export function getAddPenRsource(options) {
  return request({
    url: `/op/schoolManageSet/addPenRsource`,
    method: 'post',
    data: options
  });
}

// 未绑定、绑定学生、绑定学生与校牌C01、绑定学生与校牌C02******************************************************************************************************************************************
/**
 *修改家校圈App配置菜单
 */
export function getUpdateSchoolAppConfigMenu(options) {
  return request({
    url: `/op/schoolAppMenu/updateSchoolAppConfigMenu`,
    method: 'post',
    data: options,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 获取家校圈APP功能配置菜单
 */
export function getQueryAppConfigMenu(options) {
  return request({
    url: `/op/schoolAppMenu/queryAppConfigMenu`,
    method: 'get',
    params: options
  });
}

/**
 * 获取家校圈APP菜单
 */
export function getQueryAppMenu(options) {
  return request({
    url: `/op/schoolAppMenu/queryAppMenu`,
    method: 'get',
    params: options
  });
}

// 校牌功能配置******************************************************************************************************************************************

/**
 * 修改校牌功能配置菜单
 */
export function getUpdateConfigMenu(params, data) {
  return request({
    url: `/op/schoolIdCardConfig/updateConfigMenu`,
    method: 'post',
    params,
    data
  });
}
/**
 * 分页获取校牌功能配置列表
 */
export function getSchoolIdCardConfig(options) {
  return request({
    url: `/op/schoolIdCardConfig/query/id_card_config/page`,
    method: 'get',
    params: options
  });
}
/**
 * 获取校牌功能配置菜单
 */
export function getQueryConfigMenu(options) {
  return request({
    url: `/op/schoolIdCardConfig/queryConfigMenu`,
    method: 'get',
    params: options
  });
}

// 功能管理配置******************************************************************************************************************************************

/**
 * 改功能管理App配置菜单
 */
export function getUpdateManageAppConfigMenu(options) {
  return request({
    url: `/op/schoolAppMenu/updateManageAppConfigMenu`,
    method: 'post',
    data: options
  });
}
/**
 * 获取功能管理APP配置菜单
 */
export function getAppName(options) {
  return request({
    url: `/op/schoolAppMenu/getAppName`,
    method: 'get',
    params: options
  });
}
/**
 * 获取功能管理校牌类型
 */
export function getSchoolcardType() {
  return request({
    url: `/op/schoolAppMenu/schoolcard/type/list`,
    method: 'get'
  });
}
/**
 * 获取功能管理菜单
 */
export function getQueryManageAppMenu(options) {
  return request({
    url: `/op/schoolAppMenu/queryManageAppMenu`,
    method: 'get',
    params: options
  });
}

// 异动记录列表
export function transactionList(options) {
  return request({
    url: `/op/school-plate-repair/record/`,
    method: 'get',
    params: options
  });
}
// 异动记录学校列表
export function schoolList() {
  return request({
    url: `/op/school-plate-repair/record/school-list`,
    method: 'get'
  });
}
